import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, FileText, TrendingUp, Globe } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const THINK_TANK_BG = "https://images.unsplash.com/photo-1718638779329-0994ce1bafc5?crop=entropy&cs=srgb&fm=jpg&q=85";

export const ThinkTankSection = () => {
  const { t } = useLanguage();

  const features = [
    { icon: FileText, label: 'Rapports Annuels' },
    { icon: TrendingUp, label: 'Analyses BRICS' },
    { icon: Globe, label: 'Études Multipolaires' },
  ];

  return (
    <section
      data-testid="thinktank-section"
      className="py-24 md:py-32 bg-oar-bg-secondary relative overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={THINK_TANK_BG}
          alt="Diplomatic Conference"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-oar-bg-secondary via-oar-bg-secondary/95 to-oar-bg-secondary/80" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <span className="text-xs md:text-sm uppercase tracking-[0.2em] text-oar-red font-bold">
              Think Tank
            </span>
            <h2
              data-testid="thinktank-title"
              className="font-heading text-3xl md:text-5xl font-semibold tracking-tight text-oar-text-primary mt-4 mb-6"
            >
              {t('thinkTank.title')}
            </h2>
            <p className="text-base md:text-lg text-oar-text-secondary leading-relaxed mb-8">
              {t('thinkTank.description')}
            </p>

            {/* Features */}
            <div className="flex flex-wrap gap-4 mb-10">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 bg-white border border-oar-border px-4 py-2 rounded-lg shadow-sm"
                >
                  <feature.icon className="w-4 h-4 text-oar-blue" />
                  <span className="text-sm text-oar-text-secondary">{feature.label}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <Link
              to="/publications"
              data-testid="thinktank-cta"
              className="group inline-flex items-center gap-2 bg-oar-red hover:bg-oar-red-dark text-white rounded-lg px-8 py-4 font-medium transition-all duration-300 shadow-lg"
            >
              {t('thinkTank.cta')}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white border border-oar-border p-6 rounded-lg card-hover">
              <div className="text-4xl font-heading font-bold text-oar-blue mb-2">15+</div>
              <div className="text-sm text-oar-text-muted">Publications annuelles</div>
            </div>
            <div className="bg-white border border-oar-border p-6 rounded-lg card-hover">
              <div className="text-4xl font-heading font-bold text-oar-red mb-2">30+</div>
              <div className="text-sm text-oar-text-muted">Experts contributeurs</div>
            </div>
            <div className="bg-white border border-oar-border p-6 rounded-lg card-hover">
              <div className="text-4xl font-heading font-bold text-oar-green mb-2">5K+</div>
              <div className="text-sm text-oar-text-muted">Lecteurs mensuels</div>
            </div>
            <div className="bg-white border border-oar-border p-6 rounded-lg card-hover">
              <div className="text-4xl font-heading font-bold text-oar-orange mb-2">50+</div>
              <div className="text-sm text-oar-text-muted">Partenaires médias</div>
            </div>
          </div>
        </div>
      </div>

      {/* African line bottom */}
      <div className="africa-line absolute bottom-0 left-0 right-0" />
    </section>
  );
};
